import React, { useState } from 'react'
import {
  FormControlLabel,
  Checkbox,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Stack,
  styled,
  Theme
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CloseIcon from '@mui/icons-material/Close'

interface Props {
  accepted: boolean
  setAccepted: (value: boolean) => void
}
const BpIcon = styled('span')(({ theme }: { theme: Theme }) => ({
  borderRadius: 3,
  width: 21,
  height: 21,
  margin: 4.5,
  padding: 0,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px var(--primary), inset 0 -1px 0 var(--primary)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5'
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark'
        ? 'rgba(57,75,89,.5)'
        : 'rgba(206,217,224,.5)'
  }
}))

export const SmsConsent: React.FC<Props> = ({ accepted, setAccepted }) => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Stack direction="row" spacing={1} >
        <FormControlLabel
          className="avisoMensajeriaCheck"
          style={{marginLeft: '-11px'}}
          sx={{ 
            '& .MuiSvgIcon-root': { fontSize: '30px !important' }
          }}
          control={
            <Checkbox
              checked={accepted}
              icon={<BpIcon />}
              onChange={() => setAccepted(!accepted)}
            />
          }
          label="He leído y acepto recibir información a través de SMS."
        />

        {/* Icono que abre el aviso legal */}
        <IconButton
          aria-label="Ver información sobre el envío de SMS"
          size="small"
          color='primary'
          onClick={handleOpen}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Stack>

      {/* Modal / Dialog con la info completa */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        className='modalSMS'
      >
        <DialogTitle sx={{ pr: 6 }}>
          Información sobre mensajes SMS
          <IconButton
            aria-label="Cerrar"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2" component="p">
            Al marcar la casilla, está dando su consentimiento a Grupo Aries
            para recibir promociones, avisos y notificaciones por SMS. Al
            proporcionar su número de teléfono está aceptando la{' '}
            <a
              href={`${process.env.APP_URL}/aviso-privacidad`}
              target="_blank"
              rel="noreferrer"
            >
              Política de Privacidad
            </a>{' '}
            y{' '}
            <a
              href={`${process.env.APP_URL}/terminos-condiciones/`}
              target="_blank"
              rel="noreferrer"
            >
              Términos y Condiciones
            </a>{' '}
            de Grupo Aries. Pueden aplicarse tarifas de mensajes y datos. La
            frecuencia de los mensajes varía según el usuario. Envía <b>HELP</b>{' '}
            para obtener ayuda. Envía <b>STOP</b> para darte de baja. No se
            compartirá información móvil con terceros o afiliados con fines de
            marketing/promoción. Todas las categorías anteriores excluyen los
            datos y el consentimiento del remitente de los mensajes de texto;
            esta información no se compartirá con terceros. Los proveedores de
            telefonía no se hacen responsables de los mensajes retrasados o no
            entregados. Póngase en contacto con nosotros al teléfono{' '}
            <a href="tel:+528008003938">+52 (800) 800-3938</a> o al correo{' '}
            <a href="mailto:sac@laspuertasdemazatlan.com">
              sac@laspuertasdemazatlan.com
            </a>{' '}
            para obtener más información.
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  )
}
